import { Configuration } from '@azure/msal-browser/dist/config/Configuration';

export const B2C_SIGN_IN_AUTHORITIES = {
  signUpSignIn: process.env.SIGN_UP_SIGN_IN_B2C_AUTHORITY,
  forgotPassword: process.env.FORGOT_PASSWORD_B2C_AUTHORITY,
  editProfile: process.env.EDIT_PROFILE_B2C_AUTHORITY
};

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.APPLICATION_CLIENT_ID,
    authority: B2C_SIGN_IN_AUTHORITIES.signUpSignIn,
    redirectUri: '/',
    knownAuthorities: [process.env.B2C_POLICIES_INSTANCE],
    postLogoutRedirectUri: '/',
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true
  },
  system: {
    loggerOptions: {
      loggerCallback: () => {}
    }
  }
};

export const loginRequest = {
  scopes: ['openid', 'profile'],
  extraQueryParameters: {
    ui_locales: 'en'
  }
};
